module.exports = __webpack_public_path__ + "img/martina-fruerntatt.a2b3b3b3.jpg";